'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'palette';
var width = 512;
var height = 512;
var aliases = [127912];
var unicode = 'f53f';
var svgPathData = ['M16 256c0 130.4 103.9 236.4 233.5 239.9l47.9-47.9-.8-.8c-15.7-15.7-24.6-37.1-24.6-59.3 0-46.3 37.6-83.9 83.9-83.9l140.1 0 0-48C496 123.5 388.5 16 256 16S16 123.5 16 256zm128 40a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm32-128a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm128-64a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm128 64a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z', 'M496 304l0-48C496 123.5 388.5 16 256 16S16 123.5 16 256c0 130.4 103.9 236.4 233.5 239.9l47.9-47.9-.8-.8c-15.7-15.7-24.6-37.1-24.6-59.3 0-46.3 37.6-83.9 83.9-83.9L496 304zM308.7 436.7L320 448 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0 512 114.6 512 256l0 64-156.1 0c-37.5 0-67.9 30.4-67.9 67.9 0 18 7.2 35.3 19.9 48l.8 .8zM104 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm56-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm168-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM416 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPalette = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;